import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../Components/Breadcrumbs'
import { Box, Divider, Grid, Typography } from '@material-ui/core'
import { useStyles } from './style'
import { Link } from 'react-router-dom'
import {
  AUTHDETAILSFORTHEPROGRAM,
  OAUTHURL,
  APPENDOAUTHURLWITHREDIRECTURI,
  APPENDAUTHURLWITHSTATEPARAMETER,
  HOAUTHORIZATION,
  RETRIEVEAUTHCODEFROMREDIRECTURI,
  GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN,
  REGENERATEACCESSTOKENUSINGREFRESHTOKEN,
  ENROLLUSINGHOACCESSTOKEN
} from './constant'
import { useScrollSpy } from '../../../Components/CustomHooks'
import step4 from '../../../Assets/Images/oauthGuide/step4.png'
import step4_2 from '../../../Assets/Images/oauthGuide/step4_2.png'
import getOauthConfig from '../../../Config/oauthGuideEnv'
import getPublicApiConfig from '../../../Config/publicApiEnv'
import dev_step1 from '../../../Assets/Images/oauthGuide/dev_step1.png'
import intg_step1 from '../../../Assets/Images/oauthGuide/intg_step1.png'
import stg_step1 from '../../../Assets/Images/oauthGuide/stg_step1.png'
import prod_step1 from '../../../Assets/Images/oauthGuide/prod_step1.png'
import preprod_step1 from '../../../Assets/Images/oauthGuide/preprod_step1.png'

const items = [
  { hash: AUTHDETAILSFORTHEPROGRAM },
  { hash: OAUTHURL },
  { hash: APPENDOAUTHURLWITHREDIRECTURI },
  { hash: APPENDAUTHURLWITHSTATEPARAMETER },
  { hash: HOAUTHORIZATION },
  { hash: RETRIEVEAUTHCODEFROMREDIRECTURI },
  { hash: GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN },
  { hash: REGENERATEACCESSTOKENUSINGREFRESHTOKEN },
  { hash: ENROLLUSINGHOACCESSTOKEN }
]

const OAuthGuide = () => {
  const classes = useStyles()
  const [active, setActive] = useState(window.location.hash.replace('#', ''))
  const activeSection = useScrollSpy({ items })
  const url = getOauthConfig(process.env.NODE_ENV) && getOauthConfig(process.env.NODE_ENV).api
  const vppUrl = getPublicApiConfig(process.env.NODE_ENV) && getPublicApiConfig(process.env.NODE_ENV).api
  const [step1, setStep1] = useState('')

  const selectSection = (id) => {
    if (document.getElementById(id)) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" })
    }
  }

  useEffect(() => {
    if (activeSection) {
      setActive(activeSection)
    }
  }, [activeSection])

  useEffect(() => {
    if (active) {
      selectSection(active)
    }
    const step1Img = (url === 'https://api-dev.qa-enphaseenergy.com' ? dev_step1
    : url === 'https://api-intg.qa-enphaseenergy.com' ? intg_step1
    : url === 'https://api-qa2.enphaseenergy.com' ? stg_step1
    : url === 'https://api-preprod.enphaseenergy.com' ? preprod_step1
    : url === 'https://api.enphaseenergy.com' ? prod_step1
    : null)
    setStep1(step1Img)
  }, [])

  return (
    <>
      <Breadcrumb value={[{ 'Developer Hub': '/developer' }, { 'OAuth Guide': '/developer/oauth-guide' }]} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>OAuth Guide</Typography>
        <Box className={classes.subTitle}>All the guides and references you need to get started.</Box>
      </Box>
      <Box className={classes.cardWrapper}>
        <Grid container spacing={4}>
          <Grid item xs={10}>
            <Box className={classes.cardContent} id='scrollspy'>
              <Typography className={classes.cardTitle}>Grid Services OAuth Validation</Typography>
              <Box className={classes.cardDescription}>
                This page is an easy step-by-step guide that shows how to use the Enphase OAuth Service.</Box>
              <Box className={classes.subCard} id={AUTHDETAILSFORTHEPROGRAM}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Step 1: Auth Details for the Program
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  {`An Auth URL, Auth Client ID, and Auth Client Secret are generated for each grid services program. These are unique for a program and will be shown on API Credentials page.`}
                  <img src={step1} alt="authUrl" width="100%" />

                  {`Example:
                    Program Name: Demo Program`}
                  <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                    Auth URL: {`${url}/oauth/authorize`}
                  </Box>
                  {` Auth Client Id: 6r77sjd358fekb68v7s7k9fb9n
                    Auth Client Secret: gccnpjdq4r4uvc98sh9fegmni9lpgf2t7q265q9siinetj8lqel`
                  }
                </Box>
              </Box>
              <Box className={classes.subCard} id={OAUTHURL}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Step 2: oAuth URL
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  <Box>{`To enroll a site into a grid services program, the site must be authorized by the system owner. The oAuth URL must be sent to the system owner via email or must be embedded in the partner’s App. For the above example, oAuth URL is:
                    ${url}/oauth/authorize?response_type=code&client_id=6r77sjd358fekb68v7s7k9fb9n
                  `}</Box>
                </Box>
              </Box>
              <Box className={classes.subCard} id={APPENDOAUTHURLWITHREDIRECTURI}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Step 3: Append oAuth URL with redirect_uri
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  {`The oAuth URL must be appended with redirect_uri as a query parameter and, after homeowner approves, the site id and authorization code are sent to this redirect_uri as a query parameter. Partner can provide their own Web API or webhook URL in the redirect_uri or they can use https://oidcdebugger.com/debug as a default redirect_uri.
                    
                    Example:
                    ${url}/oauth/authorize?response_type=code&client_id=6r77sjd358fekb68v7s7k9fb9n&redirect_uri=https://oidcdebugger.com/debug
                  `}
                </Box>
              </Box>
              <Box className={classes.subCard} id={HOAUTHORIZATION}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Step 4: Homeowner authorization
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  {`When a homeowner opens the oAuth URL, Enphase login credentials must be provided. Homeowners will be redirected to the Authorization page and shown the site details. The homeowner can Approve or Reject access to their systems.`}
                  <img src={step4} alt="oauthLogin" width="100%" />
                  <img src={step4_2} alt="authUrl" width="100%" />
                </Box>
              </Box>
              <Box className={classes.subCard} id={RETRIEVEAUTHCODEFROMREDIRECTURI}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Step 5: Retrieve site id and auth code from redirect_uri
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  {`Upon completion of homeowner authorization, a get HTTP request is sent to the redirect_uri and the homeowner is redirected to the redirect_uri. If the homeowner approves access, an auth code is generated and sent to the redirect_uri along with the site ID selected by the homeowner as a query parameter. An ‘access_denied’ error message will be sent as query parameter in case of rejection.

                    For example, if the homeowner approves access:
                    https://oidcdebugger.com/debug?site_id=698913606&code=PW1lwb
                    
                    For example, if the homeowner reject access:
                    https://oidcdebugger.com/debug?error=access_denied&error_description=User%20denied%20access
                  `}
                </Box>
              </Box>
              <Box className={classes.subCard} id={GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Step 6: Generate OAuth2 access_token and refresh_token
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  {`To generate an access token, a post request must be sent to oAuth token URL with the following parameters:`}
                </Box>
                <ul>
                  <li>
                    <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                      <b>oAuth Token URL:</b> <Box className={classes.link} onClick={() => { window.open(`${url}/oauth/token`) }} component="span">{`${url}/oauth/token`}</Box>
                    </Box>
                  </li>
                  <li>
                    <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                      <b>grant_type:</b> ‘authorization_code’
                    </Box>
                  </li>
                  <li>
                    <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                      <b>redirect_uri:</b> It must be the same URI that was sent to the homeowner along with selected site id.
                    </Box>
                  </li>
                  <li>
                    <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                      <b>code:</b> Code generated after the homeowner’s approval. (In this example, it is PW1lwb)
                    </Box>
                  </li>
                </ul>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  {`The oAuth client id and oAuth client secret of the program must be sent as a basic authorization header in base64encoded(client_id:client_secret). For example, if your client_id is ‘abcd’ and client_secret is
                    ‘uvwxyz’, then base64_encoded(abcd:uvwxyz) will return ‘Basic YWJjZDp1dnd4eXo=’.
                    An access_token will be generated, and the partner can use this access token for enrolling a site in the Grid Services program using VPP API “POST application”. The validity of access_token is ‘1 day’ and of refresh_token is ‘1 month’.

                    Sample Curl Request:
                    $ curl --location --request POST
                    '${url}/oauth/token?grant_type=authorization_code&redirect_uri=https://oidc
                    debugger.com/debug?site_id=698913606&code=PW1lwb' \
                    --header 'Authorization: Basic
                    ZjJhNDc5ZjNjNjA2N2YwZDk1MTdjYWRhZTdmMDBiNDc6NTAzNWNhNjRjMTNmNzkzYTdjMWJjYTQzNTU5
                    MWQ1ZWE=' \
                    --data-raw ''</pre>

                    Sample Response:
                    {
                    "access_token": "unique access token",
                    "token_type": "bearer",
                    "refresh_token": "unique refresh token",
                    "expires_in": 86393,
                    "scope": "read write",
                    "enl_uid": "217231",
                    "enl_cid": "5",
                    "enl_password_last_changed": "1638870641",
                    "site_id":698913606,
                    "is_internal_app": false,
                    "app_type": "partner",
                    "app_Id": "grid-services-app-smart-energy",
                    "client_id": "6r77sjd358fekb68v7s7k9fb9n"
                    "jti": "1ee68d30-3e79-4347-b7ea-a5851f6f15db"
                    }
                  `}
                </Box>
              </Box>
              <Box className={classes.subCard} id={REGENERATEACCESSTOKENUSINGREFRESHTOKEN}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Step 7: Regenerate access_token using refresh_token
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  {`To re-generate an access token using refresh token, a post request must be sent to oAuth token URL with the following parameters`}
                </Box>
                <ul>
                  <li>
                    <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                      <b>oAuth Token URL:</b> <Box className={classes.link} onClick={() => { window.open(`${url}/oauth/token`) }} component="span">{`${url}/oauth/token`}</Box>
                    </Box>
                  </li>
                  <li>
                    <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                      <b>grant_type:</b> ‘refresh_token’
                    </Box>
                  </li>
                  <li>
                    <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                      <b>refresh_token:</b> ‘abcde’
                    </Box>
                  </li>
                </ul>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  {`The oauth client id and oauth client secret of the program must be sent as a basic authorization header in base64encoded(client_id:client_secret). 
                    For example, if your client_id is ‘abcd’ and client_secret is ‘uvwxyz’, then base64_encoded(abcd:uvwxyz) will return ‘Basic YWJjZDp1dnd4eXo=’. 
                    
                    An access_token will be generated, and the partner can use this access token for enrolling a site in the Grid Services program using VPP API “POST application”. The validity of access_token is ‘1 day’ and of refresh_token is ‘1 month’.

                    Sample Curl Request:
                    $ curl --location --request POST
                    '${url}/oauth/token?grant_type=refresh_token&refresh_token=abcd' \
                    --header 'Authorization: Basic
                    ZjJhNDc5ZjNjNjA2N2YwZDk1MTdjYWRhZTdmMDBiNDc6NTAzNWNhNjRjMTNmNzkzYTdjMWJjYTQzNTU5
                    MWQ1ZWE=' \
                    --data-raw ''</pre>
                    
                    Sample Response:
                    {
                    "access_token": "unique access token",
                    "token_type": "bearer",
                    "refresh_token": "unique refresh token",
                    "expires_in": 86393,
                    "scope": "read write",
                    "enl_uid": "217231",
                    "enl_cid": "5",
                    "enl_password_last_changed": "1638870641",
                    "site_id":698913606,
                    "is_internal_app": false,
                    "app_type": "partner",
                    "app_Id": "grid-services-app-smart-energy",
                    "client_id": "6r77sjd358fekb68v7s7k9fb9n"
                    "jti": "1ee68d30-3e79-4347-b7ea-a5851f6f15db"
                    }
                  `}
                </Box>
              </Box>
              <Box className={classes.subCard} id={ENROLLUSINGHOACCESSTOKEN}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <Box className={classes.subCardTitle} mx={1}>
                    Step 8: Enroll a site using ho-access-token
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  {`For submitting an application via VPP APIs, user needs to pass below 2 headers in any API requests:`}
                </Box>
                <ul>
                  <li><Box className={`${classes.subCardContent} ${classes.subCardList}`}>Authorization</Box></li>
                  <li><Box className={`${classes.subCardContent} ${classes.subCardList}`}>x-api-key</Box></li>
                </ul>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  {`For creating new applications POST API, user needs to pass additional header with below name. The value of this will be the token generated as part of oAuth process:`}
                </Box>
                <ul>
                  <li><Box className={`${classes.subCardContent} ${classes.subCardList}`}>ho-access-token</Box></li>
                </ul>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  <b>Sample curl format</b><br />
                  {`curl --location "${vppUrl}/api/v1/applications"
                      --header "Authorization: <yourApiToken>"
                      --header "x-api-key: <yourApiKey>"
                      --header "ho-access-token: <yourAuthToken>"
                      --header "Content-Type: multipart/form-data; boundary=abcd"
                      --header "Accept: */*"
                      --form "application_form="{\\"site_id\\":<yourSiteId>, \\"program_id\\":\\"<yourProgramId>\\"}""
                      --form "application_type="{\\"application_type\\":\\"enrollment\\"}""
                    `}
                </Box>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  <b>Example curl</b><br />
                  {`curl --location "${vppUrl}/api/v1/applications"
                      --header "Authorization: eyJra..tLA"
                      --header "x-api-key: TCfAxb...5H"
                      --header "ho-access-token: eyJhbGc..NTw"
                      --header "Content-Type: multipart/form-data; boundary=abcd"
                      --header "Accept: */*"
                      --form "application_form="{\\"site_id\\":1238907, \\"program_id\\":\\"DEMO_PROGRAM_ID\\"}""
                      --form "application_type="{\\"application_type\\":\\"enrollment\\"}""
                    `}
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box className={classes.scrollSpyContainer}>
              <>
                <Box className={classes.scrollSpyListText} pb={0.5}><b>On this page</b></Box>
                <Box id={AUTHDETAILSFORTHEPROGRAM} py={1} pl={0.5} onClick={() => { setActive(AUTHDETAILSFORTHEPROGRAM); selectSection(AUTHDETAILSFORTHEPROGRAM) }} className={`${active === AUTHDETAILSFORTHEPROGRAM ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/oauth-guide', hash: `#${AUTHDETAILSFORTHEPROGRAM}` }} replace>Auth Details for the Program</Link></Box>
                <Box id={OAUTHURL} py={1} pl={0.5} onClick={() => { setActive(OAUTHURL); selectSection(OAUTHURL) }} className={`${active === OAUTHURL ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/oauth-guide', hash: `#${OAUTHURL}` }} replace>OAuth URL</Link></Box>
                <Box id={APPENDOAUTHURLWITHREDIRECTURI} py={1} pl={0.5} onClick={() => { setActive(APPENDOAUTHURLWITHREDIRECTURI); selectSection(APPENDOAUTHURLWITHREDIRECTURI) }} className={`${active === APPENDOAUTHURLWITHREDIRECTURI ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/oauth-guide', hash: `#${APPENDOAUTHURLWITHREDIRECTURI}` }} replace> Append OAuth URL with redirect_uri</Link></Box>
                <Box id={HOAUTHORIZATION} py={1} pl={0.5} onClick={() => { setActive(HOAUTHORIZATION); selectSection(HOAUTHORIZATION) }} className={`${active === HOAUTHORIZATION ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/oauth-guide', hash: `#${HOAUTHORIZATION}` }} replace>Homeowner authorization</Link></Box>
                <Box id={RETRIEVEAUTHCODEFROMREDIRECTURI} py={1} pl={0.5} onClick={() => { setActive(RETRIEVEAUTHCODEFROMREDIRECTURI); selectSection(RETRIEVEAUTHCODEFROMREDIRECTURI) }} className={`${active === RETRIEVEAUTHCODEFROMREDIRECTURI ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/oauth-guide', hash: `#${RETRIEVEAUTHCODEFROMREDIRECTURI}` }} replace>Retrieve site id and auth code from redirect_uri</Link></Box>
                <Box id={GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN} py={1} pl={0.5} onClick={() => { setActive(GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN); selectSection(GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN) }} className={`${active === GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/oauth-guide', hash: `#${GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN}` }} replace>Generate OAuth2 access_token and refresh_token</Link></Box>
                <Box id={REGENERATEACCESSTOKENUSINGREFRESHTOKEN} py={1} pl={0.5} onClick={() => { setActive(REGENERATEACCESSTOKENUSINGREFRESHTOKEN); selectSection(REGENERATEACCESSTOKENUSINGREFRESHTOKEN) }} className={`${active === REGENERATEACCESSTOKENUSINGREFRESHTOKEN ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/oauth-guide', hash: `#${REGENERATEACCESSTOKENUSINGREFRESHTOKEN}` }} replace>Regenerate OAuth2 access_token and refresh_token</Link></Box>
                <Box id={ENROLLUSINGHOACCESSTOKEN} py={1} pl={0.5} onClick={() => { setActive(ENROLLUSINGHOACCESSTOKEN); selectSection(ENROLLUSINGHOACCESSTOKEN) }} className={`${active === ENROLLUSINGHOACCESSTOKEN ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/oauth-guide', hash: `#${ENROLLUSINGHOACCESSTOKEN}` }} replace>Enroll site using HO access token</Link></Box>
              </>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default OAuthGuide
